import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { ToastContainer, toast } from "react-toastify";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
  background-color: #f5f5f5;
  padding: 16px;
  box-sizing: border-box;
`;

const Card = styled.div`
  width: 100%;
  max-width: 460px;
  padding: 24px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: white;
  box-sizing: border-box;
`;

const Title = styled.h3`
  text-align: center;
  margin: 0 0 4px;
  font-size: 20px;
`;

const SubText = styled.p`
  text-align: center;
  color: #666;
  font-size: 14px;
  margin: 0 0 16px;
`;

const CodeBox = styled.div`
  background: #f0f4ff;
  border: 2px dashed #667eea;
  border-radius: 8px;
  padding: 16px;
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 2px;
  color: #333;
  text-align: center;
  word-break: break-all;
  overflow-wrap: break-word;
  box-sizing: border-box;
`;

const CopyBtn = styled.button`
  display: block;
  width: 100%;
  padding: 10px;
  margin: 0 0 12px;
  border: 2px solid #667eea;
  border-radius: 8px;
  background: transparent;
  color: #667eea;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    background: #667eea;
    color: #fff;
  }
`;

const Warning = styled.div`
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 12px;
  margin: 0 0 16px;
  font-size: 12px;
  color: #856404;
  line-height: 1.6;
  box-sizing: border-box;
`;

const PrimaryBtn = styled.button`
  display: block;
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  background: #282c34;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    opacity: 0.9;
  }
`;

const SecondaryBtn = styled.button`
  display: block;
  width: 100%;
  padding: 12px;
  margin-top: 10px;
  border: 1px solid #282c34;
  border-radius: 8px;
  background: #fff;
  color: #282c34;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;
`;

const MemberSecretRegister = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const recoveryCode = location.state?.recoveryCode || "";

  const handleCopy = () => {
    if (!recoveryCode) return;
    navigator.clipboard.writeText(recoveryCode).then(() => {
      setCopied(true);
      toast.success("コピーしました");
      setTimeout(() => setCopied(false), 3000);
    }).catch(() => {
      toast.error("コピーに失敗しました。手動で控えてください。");
    });
  };

  return (
    <Container>
      <Card>
        <Title>会員登録が完了しました</Title>
        <SubText>まずはこの復旧コードを控えてください</SubText>

        <CodeBox>
          {recoveryCode || "キーの表示に失敗しました"}
        </CodeBox>

        <CopyBtn onClick={handleCopy}>
          {copied ? "コピー済み" : "キーをコピーする"}
        </CopyBtn>

        <Warning>
          このキーは再表示されません。
          パスワードを忘れた時に使うので、スクリーンショットやメモなどに残してください。
        </Warning>

        <PrimaryBtn onClick={() => navigate("/Register")}>
          最初の夢を投稿する
        </PrimaryBtn>
        <SecondaryBtn onClick={() => navigate("/MyPage")}>
          先にマイページへ進む
        </SecondaryBtn>
      </Card>
      <ToastContainer position="top-center" autoClose={3000} />
    </Container>
  );
};

export default MemberSecretRegister;
